.homepage {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2rem;

  background: linear-gradient(90deg, #e3ffe7 0%, #d9e7ff 100%);
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

@media (width < 500px) {
  .homepage {
    padding: 1rem;
    gap: 1rem;
  }
}

.homepage header {
  width: 100%;
  display: flex;
  justify-content: center;

  font-weight: bold;
  font-size: 2rem;
}

@media (width < 500px) {
  .homepage header {
    font-size: 1.35rem;
  }
}

.buttons-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.buttons-container button {
  padding: 0.75rem;

  border: 0;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  background-color: black;
  border: 1px solid lightslategray;
  color: white;

  cursor: pointer;
}

.buttons-container button:disabled {
  background-color: transparent;
  border: 1px solid lightslategray;
  color: lightslategray;

  cursor: not-allowed;
}

.instructions {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  font-size: 1.25rem;
}

@media (width < 500px) {
  .instructions {
    gap: 0.25rem;

    font-size: 1rem;
  }
}

.instructions li {
  display: flex;
  align-items: center;
  gap: 1rem;
}

@media (width < 500px) {
  .instructions li {
    gap: 0.5rem;
  }
}

.instructions img {
  width: 25px;
}

@media (width < 500px) {
  .instructions img {
    width: 20px;
  }
}
